export enum DASHBOARD_FILTERS {
  FILES = "files",
  GROUPS = "groups",
  USERS = "users"
}
